// 文明ビット内訳: bit 0 = 無色, bit 1〜5 = 光・水・闇・火・自然
export const COLOR_BITS_MASK = 0b111110

export function popcount(x: number): number {
  x = x - ((x >>> 1) & 0x55555555)
  x = (x & 0x33333333) + ((x >>> 2) & 0x33333333)
  x = (x + (x >>> 4)) & 0x0f0f0f0f
  return ((x * 0x01010101) >>> 24) & 0x3f
}

/**
 * 文明数を計算する。
 * 有色（光〜自然）が含まれる場合は無色を数えず有色のみカウント、
 * 無色のみの場合は 1 として扱う。
 */
export function cultureCountFromBits(bits: number): number {
  const colorBits = bits & COLOR_BITS_MASK
  if (colorBits) return popcount(colorBits)
  return bits & 1 ? 1 : 0
}
